export default function ({ $auth, redirect, store }) {
    if (!$auth.loggedIn || !store?.state?.auth?.user?.is_admin) redirect('/')
}
